export default {
  min: {
    title:
      'Dostawa pod Twój adres: Kwota potrzebna do osiągnięcia minimalnej wartości zamówienia (Suma częściowa bez kosztów dostawy i napiwku)',
    description:
      'Przepraszamy, nie możesz jeszcze złożyć zamówienia. {{name}} ustalił minimalną kwotę zamówienia wynoszącą {{threshold}} (bez kosztów dostawy)',
  },
  max: {
    title: 'Osiągnięto maksymalną wartość zamówienia z dostawą (łącznie bez kosztów dostawy)',
    description:
      'Twoje zamówienie przekroczyło maksymalną dozwoloną wartość {{threshold}} dla dostawy online. W przypadku zamówień przekraczających tę kwotę prosimy o bezpośredni kontakt, abyśmy mogli zorganizować dostawę. Dziękujemy za wyrozumiałość!',
  },
};
